"use client"

import { signOut } from "@/api/app/auth/login/fetchers"
import axios from "@/lib/axios"
import jwt_decode from "jwt-decode"
import { useSession } from "next-auth/react"
import { useCallback } from "react"

const useRefreshToken = () => {
	const { data: session, update } = useSession()

	const refreshToken = useCallback(async () => {
		try {
			const { data } = await axios.post("/token/refresh", {
				refresh_token: session?.user.refreshToken,
			})

			if (session) {
				const decodedToken = jwt_decode(data.token)
				await update({
					accessToken: data.token,
					accessTokenExpires: Date.now() + decodedToken.exp * 1000,
					refreshToken:
						data.refresh_token ?? session.user.refreshToken,
				})
			}
		} catch (error) {
			console.log("IN ERROR")

			signOut()
		}
	}, [session, update])

	return refreshToken
}

export default useRefreshToken
